import {
  deleteApiCaller,
  getApiCaller,
  postApiCaller,
  putApiCaller,
  postFormDataApiCaller,
  putFormDataApiCaller,
} from "../apiCaller";

export const getAllLanguages = async (page = 1, limit = 10, search = "") => {
  const response = await getApiCaller(
    `language/get-all?search=${search}&page=${page}&limit=${limit}`
  );
  return response;
};

export const postLanguage = async (payload = {}) => {
  const response = await postApiCaller("language/create", payload);
  return response;
};

export const addLanguage = async (payload) => {
  // Check if payload is FormData
  if (payload instanceof FormData) {
    const response = await postFormDataApiCaller("language/create", payload);
    return response;
  }
  const response = await postApiCaller("language/create", payload);
  return response;
};

export const updateLanguage = async (selectedLangId, payload) => {
  // Check if payload is FormData
  if (payload instanceof FormData) {
    const response = await putFormDataApiCaller(`language/${selectedLangId}`, payload);
    return response;
  }
  const response = await putApiCaller(`language/${selectedLangId}`, payload);
  return response;
};

export const deleteLanguage = async (langId) => {
  const response = await deleteApiCaller(`language/${langId}`);
  return response;
};

export const languageSequence = async (payload) => {
  const response = await putApiCaller("language/sequence", payload);
  return response;
};
